import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/adjust.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/angle-down-small.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/angle-left-small.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/angle-right-small.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/arrow-down-sprite.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/bath-tub.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/bathtub-type.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/charge.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/chevron-left.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/chevron-right.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/circle-down.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/circle-next.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/CircleDownIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/close.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/cloud.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/double-bed.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/drop-down.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/emailIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/expand.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/facebook-black.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/filterIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/full-screen-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/info-circle.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/instagram-black.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/letter.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/line-black.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/location.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/map-search.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/map.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/marker-pin-04.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/onsen.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/parkingSpaces.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/phone.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/photos-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/point-1.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/point-2.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/point-3.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/room.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/shower-type.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/slider-next.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/slider-prev.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/smoke.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/spinner.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/sprite-chat.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/sprite-icon-web.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/sprite-mail.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/sprite-phone.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/swimming-pool.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/toilet-type.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/toilet.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/user.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/white-circle-next.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/wifi.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/x-black.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/youtube-black.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/atoms/rich-text-render/RichTextRender.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Gallery"] */ "/app/src/components/organisms/Gallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BrandkamenoiHotel"] */ "/app/src/components/organisms/kamenoi-hotels/BrandKamenoiHotels.tsx");
